<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>流程行</el-breadcrumb-item>
        </el-breadcrumb>
        <el-tabs v-model="activeName" type="border-card" @tab-click="tabClick" style="margin-top: 10px">
            <el-row class="main_header">
                <div class="main_header_item">
                    <el-select v-model="rel_type" placeholder="请选择对象类型" clearable filterable>
                        <el-option v-for="item in productOptions" :key="item.rel_type" :label="item.rel_name" :value="item.rel_type">
                        </el-option>
                    </el-select>
                </div>
            </el-row>
            <el-tab-pane label="全部" name="1">
                <div class="main_list">
                    <div class="flex">
                        <div class="main_header_btns">
                            <el-button type="primary" size="small" @click="getList(0,1)">搜索</el-button>
                            <el-button size="small" type="primary" plain @click="reset">重置</el-button>
                            <el-popover placement="left" trigger="click" class="top_btn" width="200px">
                                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
                                    >全选</el-checkbox
                                >
                                <el-checkbox-group
                                    v-model="colOptions"
                                    style="display: flex; flex-direction: column"
                                    @change="handleCheckedCitiesChange"
                                >
                                    <el-checkbox v-for="item in colSelect" :label="item" :key="item"></el-checkbox>
                                </el-checkbox-group>
                                <el-button slot="reference" size="mini" icon="el-icon-setting">设置</el-button>
                            </el-popover>
                        </div>
                    </div>
                    <el-table
                        :data="tableData"
                        border
                        style="width: 100%"
                        ref="tableDataRef"
                        element-loading-text="数据拼命加载中"
                        @sort-change="changeSort"
                        :max-height="this.$tableHeight"
                    >
                        <el-table-column
                            v-if="colData[0].istrue"
                            prop="rel_name"
                            label="对象名称"
                            align="left"
                            show-overflow-tooltip
                            width="120px"
                        >
                        </el-table-column>
                        <el-table-column v-if="colData[1].istrue" prop="name" label="流程行名称" align="left" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            v-if="colData[2].istrue"
                            prop="status_label"
                            label="状态"
                            align="left"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column v-if="colData[3].istrue" prop="type_label" label=" 类型" align="left" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            v-if="colData[4].istrue"
                            prop="operator_hierarchy_names"
                            label="可审批职位"
                            align="left"
                            show-overflow-tooltip
                            width="320px"
                        >
                        </el-table-column>
                        <el-table-column v-if="colData[5].istrue" prop="operator_name" label="审批人" align="left" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            v-if="colData[6].istrue"
                            prop="operator_hierarchy_name"
                            label="审批人职位"
                            align="left"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            v-if="colData[7].istrue"
                            prop="operation_label"
                            label="执行意见"
                            align="left"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            v-if="colData[8].istrue"
                            prop="comment"
                            label="意见说明"
                            align="left"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            v-if="colData[9].istrue"
                            prop="sequence"
                            label="序号"
                            align="left"
                            show-overflow-tooltip
                            width="120px"
                        >
                        </el-table-column>
                        <el-table-column
                            v-if="colData[10].istrue"
                            prop="next_sequence"
                            label="下一步序号"
                            align="left"
                            show-overflow-tooltip
                            width="120px"
                        >
                        </el-table-column>
                        <el-table-column
                            v-if="colData[11].istrue"
                            prop="operator_number"
                            label="执行人数"
                            align="left"
                            show-overflow-tooltip
                            width="120px"
                        >
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total,prev, pager, next, sizes, jumper"
                            @current-change="currentChange"
                            @size-change="sizeChange"
                            :page-sizes="[25,50,75,100]"
                            :current-page.sync="page"
                            :total="total"
                        ></el-pagination>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="待我审批" name="2">
                <span slot="label">
                    待我审批 <el-badge v-show="activeValue2 > 0" :max="99" :value="activeValue2" class="item"> </el-badge
                ></span>
                <div class="main_list">
                    <div class="flex">
                        <el-button class="btn_success" size="small" plain @click="okPass(3)" :loading="btnLoading3">批量通过</el-button>
                        <el-button class="btn_error" size="small" plain @click="okPass(4)" :loading="btnLoading4">批量拒绝</el-button>
                        <div class="main_header_btns">
                            <el-button type="primary" size="small" @click="getList(0,1)">搜索</el-button>
                            <el-button size="small" type="primary" plain @click="reset">重置</el-button>
                            <el-popover placement="left" trigger="click" class="top_btn" width="200px">
                                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
                                    >全选</el-checkbox
                                >
                                <el-checkbox-group
                                    v-model="colOptions"
                                    style="display: flex; flex-direction: column"
                                    @change="handleCheckedCitiesChange"
                                >
                                    <el-checkbox v-for="item in colSelect" :label="item" :key="item"></el-checkbox>
                                </el-checkbox-group>
                                <el-button slot="reference" size="mini" icon="el-icon-setting">设置</el-button>
                            </el-popover>
                        </div>
                    </div>
                    <el-table
                        :data="tableData"
                        border
                        style="width: 100%"
                        ref="tableDataRef"
                        element-loading-text="数据拼命加载中"
                        @selection-change="selectionChange"
                        @sort-change="changeSort"
                        :max-height="this.$tableHeight"
                    >
                        <el-table-column type="selection" width="55" fixed="left"></el-table-column>
                        <el-table-column
                            v-if="colData[0].istrue"
                            prop="rel_name"
                            label="对象名称"
                            align="left"
                            show-overflow-tooltip
                            width="120px"
                        >
                        </el-table-column>
                        <el-table-column v-if="colData[1].istrue" prop="name" label="流程行名称" align="left" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            v-if="colData[2].istrue"
                            prop="status_label"
                            label="状态"
                            align="left"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column v-if="colData[3].istrue" prop="type_label" label=" 类型" align="left" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            v-if="colData[4].istrue"
                            prop="operator_hierarchy_names"
                            label="可审批职位"
                            align="left"
                            show-overflow-tooltip
                            width="320px"
                        >
                        </el-table-column>
                        <!-- <el-table-column v-if="colData[5].istrue" prop="operator_name" label="审批人" align="left" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            v-if="colData[6].istrue"
                            prop="operator_hierarchy_name"
                            label="审批人职位"
                            align="left"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            v-if="colData[7].istrue"
                            prop="operation_label"
                            label="执行意见"
                            align="left"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            v-if="colData[8].istrue"
                            prop="comment"
                            label="意见说明"
                            align="left"
                            show-overflow-tooltip
                        ></el-table-column> -->
                        <el-table-column
                            v-if="colData[9].istrue"
                            prop="sequence"
                            label="序号"
                            align="left"
                            show-overflow-tooltip
                            width="120px"
                        >
                        </el-table-column>
                        <el-table-column
                            v-if="colData[10].istrue"
                            prop="next_sequence"
                            label="下一步序号"
                            align="left"
                            show-overflow-tooltip
                            width="120px"
                        >
                        </el-table-column>
                        <el-table-column
                            v-if="colData[11].istrue"
                            prop="operator_number"
                            label="执行人数"
                            align="left"
                            show-overflow-tooltip
                            width="120px"
                        >
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total,prev, pager, next, sizes, jumper"
                            @current-change="currentChange"
                            @size-change="sizeChange"
                            :page-sizes="[25,50,75,100]"
                            :current-page.sync="page"
                            :total="total"
                        ></el-pagination>
                    </div>
                    <el-dialog :close-on-click-modal="false" title="审核意见" :visible.sync="dialogVisible" width="30%" v-dialogDrag>
                        <el-input type="textarea" :rows="2" placeholder="请输入审核意见" v-model="comment"> </el-input>
                        <span slot="footer" class="dialog-footer">
                            <el-button
                                @click="
                                    dialogVisible = false;
                                    comment = '';
                                "
                                >取 消</el-button
                            >
                            <el-button type="primary" @click="subData">确 定</el-button>
                        </span>
                    </el-dialog>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
export default {
    name: 'processLineList',
    data() {
        return {
            comment: '',
            dialogVisible: false,
            dataType: '',
            btnLoading3: false,
            btnLoading4: false,
            activeValue2: 0,
            activeName: '1',
            tableData: [],
            sort: '', //排序参数
            data_name: '', //排序参数
            //控制列
            colData: [
                { title: '对象名称', istrue: true },
                { title: '流程行名称', istrue: true },
                { title: '状态', istrue: true },
                { title: '类型', istrue: true },
                { title: '可审批职位', istrue: true },
                { title: '审批人', istrue: true },
                { title: '审批人职位', istrue: true },
                { title: '执行意见', istrue: true },
                { title: '意见说明', istrue: true },
                { title: '序号', istrue: true },
                { title: '下一步序号', istrue: true },
                { title: '执行人数', istrue: true }
            ],
            colOptions: [
                '对象名称',
                '流程行名称',
                '状态',
                '类型',
                '可审批职位',
                '审批人',
                '审批人职位',
                '执行意见',
                '意见说明',
                '序号',
                '下一步序号',
                '执行人数'
            ], //默认全选
            // 筛选列
            colSelect: [
                '对象名称',
                '流程行名称',
                '状态',
                '类型',
                '可审批职位',
                '审批人',
                '审批人职位',
                '执行意见',
                '意见说明',
                '序号',
                '下一步序号',
                '执行人数'
            ],
            rel_type: '', //产品id
            checkAll: true,
            isIndeterminate: false,
            productOptions: [], //产品列表
            states: [],
            total: 0,
            page: 1,
            row: 25,
            selected: []
        };
    },
    computed: {
        listSet() {
            return this.states.map((item) => {
                return { value: `${item.rid}`, label: `${item.name}` };
            });
        }
    },
    watch: {
        //控制列显示
        colOptions(valArr) {
            var arr = this.colSelect.filter((i) => valArr.indexOf(i) < 0); // 未选中
            this.colData.filter((i) => {
                if (arr.indexOf(i.title) != -1) {
                    i.istrue = false;
                    this.$nextTick(() => {
                        this.$refs.tableDataRef.doLayout();
                    });
                } else {
                    i.istrue = true;
                    this.$nextTick(() => {
                        this.$refs.tableDataRef.doLayout();
                    });
                }
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getList(0,1); //获取列表
            this.getCount(); //获取待我审批数量
            this.getProcedure(); //获取类型
        });
    },
    methods: {
        //全选设置列表 列显示
        handleCheckAllChange(val) {
            this.isIndeterminate = false;
            if (val) {
                this.colOptions = [
                    '对象名称',
                    '流程行名称',
                    '状态',
                    '类型',
                    '可审批职位',
                    '审批人',
                    '审批人职位',
                    '执行意见',
                    '意见说明',
                    '序号',
                    '下一步序号',
                    '执行人数'
                ];
                this.colSelect = [
                    '对象名称',
                    '流程行名称',
                    '状态',
                    '类型',
                    '可审批职位',
                    '审批人',
                    '审批人职位',
                    '执行意见',
                    '意见说明',
                    '序号',
                    '下一步序号',
                    '执行人数'
                ];
            } else {
                this.colOptions = [];
            }
        },
        //单选设置列表 列显示
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.colData.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.colData.length;
        },
        //切换tab
        tabClick() {
            this.reset();
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (this.sort !== '') {
                this.getList(0,1); //获取列表
            }
        },
        //type == 3审批通过 type ==4 拒绝
        okPass(type) {
            this.dataType = type;
            if (this.selected.length == 0) {
                this.$message.warning('当前未选择审核数据！');
                return false;
            } else {
                this.dialogVisible = true;
            }
        },
        //提交通过拒绝弹窗
        subData() {
            if (this.dataType == 3) {
                //此处为通过
                this.btnLoading3 = true;
                let approvalList = [];
                this.selected.forEach((value) => {
                    approvalList.push({
                        rel_rid: value.rel_rid,
                        rel_type: value.rel_type
                    });
                });
                let postData = {
                    rel_data: approvalList,
                    approval_status: 3,
                    comment: this.comment
                };
                this.$api
                    .procedureLineBatchAudit(postData)
                    .then((res) => {
                        this.btnLoading3 = false;
                        if (res.code == 0) {
                            this.$message({
                                message: '批量修改成功!',
                                type: 'success'
                            });
                            this.getList(0,1); //获取列表
                            this.getCount();
                            this.dialogVisible = false;
                        } else if (res.code == 1900) {
                            this.$message({
                                message: '批量修改成功，部分数据没有权限修改!',
                                type: 'success'
                            });
                            this.getList(0,1); //获取列表
                            this.getCount();
                            this.dialogVisible = false;
                        }
                    })
                    .catch((error) => {
                        this.btnLoading3 = false;
                        this.dialogVisible = false;
                        
                    });
            } else if (this.dataType == 4) {
                //此处为
                this.btnLoading4 = true;
                let approvalList = [];
                this.selected.forEach((value) => {
                    approvalList.push({
                        rel_rid: value.rel_rid,
                        rel_type: value.rel_type
                    });
                });
                let postData = {
                    rel_data: approvalList,
                    approval_status: 4,
                    comment: this.comment
                };
                this.$api
                    .procedureLineBatchAudit(postData)
                    .then((res) => {
                        this.btnLoading4 = false;
                        if (res.code == 0) {
                            this.$message({
                                message: '批量修改成功!',
                                type: 'success'
                            });
                            this.getList(0,1); //获取列表
                            this.dialogVisible = false;
                        } else if (res.code == 1900) {
                            this.$message({
                                message: '批量修改成功，部分数据没有权限修改!',
                                type: 'success'
                            });
                            this.getList(0,1); //获取列表
                            this.dialogVisible = false;
                        }
                    })
                    .catch((error) => {
                        this.btnLoading4 = false;
                        this.dialogVisible = false;
                        
                    });
            }
        },
        // 多选选择框选择
        selectionChange(val) {
            this.selected = val;
        },
        //获取对象类型
        getProcedure() {
            var params = {};
            this.$api
                .procedureRelType(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.productOptions = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //获取待我审批数量
        getCount() {
            var params = {
                page: this.page,
                row: this.row,
                tab_type: 2
            };
            this.$api
                .procedureLineLists(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.activeValue2 = res.data.total;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var num = type_data;
            var params = {
                page: this.page,
                row: this.row,
                rel_type: this.rel_type,
                is_export: num,
                tab_type: this.activeName
            };
            if (num == 0) {
                this.$api
                    .procedureLineLists(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            if (this.activeName == 2) {
                                this.activeValue2 = res.data.total;
                            }
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.rel_type = '';
            this.page = 1;
            this.row = 25;
            this.getList(0,1);
            this.isIndeterminate = false;
            this.checkAll = true;
            if (this.activeName == 1) {
                this.colData = [
                    { title: '对象名称', istrue: true },
                    { title: '流程行名称', istrue: true },
                    { title: '状态', istrue: true },
                    { title: '类型', istrue: true },
                    { title: '可审批职位', istrue: true },
                    { title: '审批人', istrue: true },
                    { title: '审批人职位', istrue: true },
                    { title: '执行意见', istrue: true },
                    { title: '意见说明', istrue: true },
                    { title: '序号', istrue: true },
                    { title: '下一步序号', istrue: true },
                    { title: '执行人数', istrue: true }
                ];
                this.colOptions = [
                    '对象名称',
                    '流程行名称',
                    '状态',
                    '类型',
                    '可审批职位',
                    '审批人',
                    '审批人职位',
                    '执行意见',
                    '意见说明',
                    '序号',
                    '下一步序号',
                    '执行人数'
                ];
                this.colSelect = [
                    '对象名称',
                    '流程行名称',
                    '状态',
                    '类型',
                    '可审批职位',
                    '审批人',
                    '审批人职位',
                    '执行意见',
                    '意见说明',
                    '序号',
                    '下一步序号',
                    '执行人数'
                ];
            } else {
                this.colData = [
                    { title: '对象名称', istrue: true },
                    { title: '流程行名称', istrue: true },
                    { title: '状态', istrue: true },
                    { title: '类型', istrue: true },
                    { title: '可审批职位', istrue: true },
                    { title: '审批人', istrue: false },
                    { title: '审批人职位', istrue: false },
                    { title: '执行意见', istrue: false },
                    { title: '意见说明', istrue: false },
                    { title: '序号', istrue: true },
                    { title: '下一步序号', istrue: true },
                    { title: '执行人数', istrue: true }
                ];
                this.colOptions = [
                    '对象名称',
                    '流程行名称',
                    '状态',
                    '类型',
                    '可审批职位',
                    '审批人',
                    '审批人职位',
                    '执行意见',
                    '意见说明',
                    '序号',
                    '下一步序号',
                    '执行人数'
                ];
                this.colSelect = ['对象名称', '流程行名称', '状态', '类型', '可审批职位', '序号', '下一步序号', '执行人数'];
            }
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>